module.exports = __webpack_public_path__ + "static/media/zh_wco.d5e5bab5.png";